<!--
 * @Description: 业绩参与人
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-13 18:26:45
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2025-10-29 14:28:55
-->
<template>
  <div class="performance-page">
    <div class="performance-col-page">
      <div class="card-edit-header">
        <div class="card-edit-header-title">{{ $t('业绩参与人') }}</div>
        <div v-if="userInfo?.roles?.indexOf('007001170') !== -1 && permission == 1" class="update-document">
          <jw-link @click="addPerformance">{{ $t('新增业绩参与人') }}</jw-link>
        </div>
      </div>
    </div>
    <div class="card-performance-content">
      <jw-table sticky-header :span-method="dataSpanMethod" :bordered="{ wrapper: true, cell: true }" :pagination="false" :data="list" :loading="loading" ref="xlUserTable" :columns="columns">
        <template #deptName="{ record }">
          <jw-tooltip :content="record.deptName" position="rt" mini v-if="record.deptName">
            <span style="cursor: pointer">{{ updateDeptName(record?.deptName) }}</span></jw-tooltip
          >
          <template v-else>-</template>
        </template>
        <template #user="{ record }">
          <p v-if="record.user" style="display: flex; align-items: center"><xl-avatar :avatar="{ name: record.user?.userName || '', url: record.user?.avatar, id: record.user?.userId }" :size="22" /></p>
          <!-- <jw-tag size="small" color="#F53F3F" v-if="record.charge">商机负责人</jw-tag> -->
          <template v-else> - </template>
        </template>
        <template #roleLabel="{ record }">
          <span v-if="record.roleLabel">{{ record.roleLabel }}</span>
          <template v-else>-</template>
        </template>
        <template #createUser="{ record }">
          <xl-avatar v-if="record.createUser" :avatar="{ name: record?.createUser?.userName || '', url: record.createUser?.avatar, id: record.createUser?.userId }" :size="22" />
          <template v-else> - </template>
        </template>
        <template #updateUser="{ record }">
          <xl-avatar v-if="record.updateUser" :avatar="{ name: record.updateUser?.userName || '', url: record.updateUser?.avatar, id: record.updateUser?.userId }" :size="22" />
          <template v-else> - </template>
        </template>
        <template #operation="{ record }">
          <template v-if="userInfo?.roles?.indexOf('007001170') !== -1 && permission == 1">
            <div style="display: flex">
              <jw-link @click="update(record)">{{ $t('编辑') }}</jw-link>
              <jw-link @click="deleteHandle(record)">{{ $t('删除') }}</jw-link>
            </div>
          </template>
          <template v-else>--</template>
        </template>
      </jw-table>
      <!-- 新增编辑业绩参与人 -->
      <update-performance ref="uploadPerformanceRefs" @cb="getList"></update-performance>
      <!-- 删除提示 -->
      <template>
        <jw-modal v-model:visible="modalVisible" @ok="handleOk" @cancel="handleCancel" title-align="start">
          <template #title> {{ $t('温馨提示') }} </template>
          <div>{{ $t('是否确认删除') }}</div>
        </jw-modal>
      </template>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, inject, ref, onMounted } from 'vue';
import useLoading from '@/hooks/loading';
import { opportunityService } from '@/api/';
import updatePerformance from './update-performance/index.vue'; //新增编辑
import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    updatePerformance
  },
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props, ctx);
    const { loading, setLoading } = useLoading(false);
    const uploadPerformanceRefs = ref(); //新增编辑
    const { userInfo } = useUserStore(); //用户信息
    const data = reactive({
      id: inject('detailParams').id,
      entity: inject('detailParams').entity,
      permission: inject('detailParams')?.permission, //权限
      copyValue: '',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        model: 1,
        showPageSize: false, // 是否显示数据条数选择器
        pageSizeOptions: [10, 20, 30, 40, 50, 100],
        showTotal: true // 是否显示数据总数
      },
      list: [],
      page: 1,
      modalVisible: false,
      record: []
    });
    const dataSpanMethod = ({ record, column }) => {
      // const customLens = data.list?.filter((i) => i.roleLabel == record.roleLabel);
      const userLens = data.list?.filter((i) => i.user.userId == record.user.userId);
      if (record.id == userLens[0]?.id && column.dataIndex === 'roleLabel') {
        return {
          rowspan: userLens?.length
        };
      }
      if (record.id == userLens[0]?.id && column.dataIndex === 'user') {
        return {
          rowspan: userLens?.length
        };
      }
    };
    // 表格头部标题
    const columns = [
      {
        title: t('业绩参与人'),
        dataIndex: 'user',
        slotName: 'user',
        width: 200
      },
      {
        title: t('角色'),
        dataIndex: 'roleLabel',
        slotName: 'roleLabel',
        width: 120
      },
      {
        title: t('协作阶段'),
        dataIndex: 'stageLabel',
        // slotName: 'stageLabel',
        width: 150,
        ellipsis: true,
        tooltip: true
      },
      {
        title: t('绩效比例'),
        dataIndex: 'weight',
        // slotName: 'weight',
        width: 100
      },
      {
        title: t('部门'),
        dataIndex: 'deptName',
        slotName: 'deptName',
        width: 120
      },
      {
        title: t('创建人'),
        dataIndex: 'createUser',
        slotName: 'createUser',
        width: 150
      },
      {
        title: t('创建时间'),
        dataIndex: 'createTime',
        // slotName: 'createTime',
        width: 180
      },
      {
        title: t('最后更新人'),
        dataIndex: 'updateUser',
        slotName: 'updateUser',
        width: 150
      },
      {
        title: t('最后更新时间'),
        dataIndex: 'updateTime',
        width: 180
      },
      {
        title: t('操作'),
        dataIndex: 'operation',
        slotName: 'operation',
        width: 150,
        fixed: 'right'
      }
    ];
    const updateDeptName = (deptName) => {
      const list = deptName.split('/');
      const lens = list.length - 1;
      return list[lens];
    };
    //获取参与人列表
    const getList = async () => {
      setLoading(true);
      data.list = [];
      const params = {
        id: data.id,
        entity: data.entity
      };
      try {
        const json = await opportunityService.getStageWeights(params);
        setLoading(false);
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        const record = sort(json?.result);
        console.log(record);
        data.list = record;
        // data.pagination.total = json.result?.total;
      } catch (e) {
        console.log(e);
      }
    };
    //分页
    const pageChange = (current) => {
      data.page = current;
      data.pagination.current = current;
      getList();
    };
    const sort = (arr) => {
      const map = {};
      arr.forEach((item) => {
        if (map[item.user.userId]) {
          map[item.user.userId].push(item);
        } else {
          map[item.user.userId] = [item];
        }
      });

      return Object.values(map).flat();
    };
    //编辑
    const update = (record) => {
      const params = {
        userId: [record.user.userName],
        user: record.user,
        role: record.role, //角色
        weights: [{ id: record.id, stage: record.stage, weight: Number(record?.weight.split('%')[0]) }]
      };
      uploadPerformanceRefs.value.open(0, params);
    };
    //删除
    const deleteHandle = (record) => {
      data.modalVisible = true;
      data.record = record;
    };
    const handleOk = () => {
      deleteDoc();
    };
    const handleCancel = () => {
      data.record = [];
      data.modalVisible = false;
    };
    const deleteDoc = async () => {
      setLoading(true);
      try {
        const json = await opportunityService.deleteStageWeights({ id: data.record.id });
        setLoading(false);
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        Message.success(t('删除成功'));
        getList();
      } catch (e) {
        console.log(e);
      }
    };
    //新增业绩参与人
    const addPerformance = () => {
      uploadPerformanceRefs.value.open(1, data.list);
    };
    onMounted(() => {
      // console.log(getCloudDocument);
      getList();
    });
    return {
      columns,
      loading,
      uploadPerformanceRefs,
      update,
      userInfo,
      sort,
      dataSpanMethod,
      handleOk,
      handleCancel,
      deleteHandle,
      deleteDoc,
      pageChange,
      addPerformance,
      getList,
      updateDeptName,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
